<div class="page-background-blue">
  <ion-grid>
    <ion-row>
      <h1 class="bottom-sheet-title">Syndicate agreement</h1>
    </ion-row>
    <ion-row>
      <p class="bottom-sheet-content">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
        Fusce neque sem, tempor nec feugiat sed, tincidunt in sapien.
        Morbi pharetra lectus a nulla tempor, vitae faucibus tortor condimentum.
        Aenean tincidunt risus ut pellentesque ultricies. Nam vitae mauris tincidunt
        ex molestie volutpat vitae ut nisl. Etiam malesuada, nisl ut molestie venenatis,
        metus purus commodo nisl, sed tristique ipsum dui mattis odio. Phasellus vehicula,
        nisl nec feugiat rutrum, nulla augue viverra lacus, vel viverra leo quam et dui. Vivamus
        vehicula semper velit, et euismod dolor euismod at. Integer blandit metus purus, ut condimentum
        odio iaculis sed. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce neque sem, tLorem
        ipsum dolor sit amet, consectetur adipiscing elit. Fusce neque sem, tLorem ipsum dolor sit amet, consectetur
        adipiscing elit. Fusce neque sem, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce neque sem,
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce neque sem, t
        odio iaculis sed. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce neque sem, tLorem
        ipsum dolor sit amet, consectetur adipiscing elit. Fusce neque sem, tLorem ipsum dolor sit amet, consectetur
        adipiscing elit. Fusce neque sem, Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce neque sem,
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce neque sem, t
      </p>
    </ion-row>
    <ion-row>
      <h1 class="bottom-sheet-back-link" (click)="backToSyndicate()">&larr; Back</h1>
    </ion-row>
  </ion-grid>
</div>
